import React from 'react';
import { CheckInDetailsRoutePaths, PathName } from '../../helpers/Routes';
import { Route, Routes, useNavigate, useResolvedPath } from 'react-router-dom';
import { LoadAppointment } from '../Utility/LoadAppointment';
import { CheckInDetailsLanding } from './CheckInDetailsLanding/CheckInDetailsLanding';
import { IAppointment } from '../../API/GoMoto';
import store from 'store2';

export const CheckInDetailsIndex: React.FC = React.memo(() => {
    const { pathname } = useResolvedPath('.');
    const navigate = useNavigate();

    return (
        <Routes>
            <Route
                path={PathName(CheckInDetailsRoutePaths.Appointment, ':apptKey', '*')}
                element={
                    <LoadAppointment
                        onLoaded={(appointment: IAppointment) => {
                            store.session.set('tempAppointment', appointment);
                            navigate(PathName(pathname, CheckInDetailsRoutePaths.Landing));
                        }}
                    />
                }
            />
            <Route
                path={PathName(CheckInDetailsRoutePaths.Landing, '*')}
                element={
                    <CheckInDetailsLanding />
                }
            />
        </Routes>
    );
});